module.exports = __webpack_public_path__ + "static/media/dbank.069d648f.png";